module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"assignTo":"Assign to","me":"Me"},"et":{"assignTo":"Assign to","me":"Me"},"ru":{"assignTo":"Assign to","me":"Me"}}')
  delete Component.options._Ctor
}
